import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Tooltip, Modal, ModalBody, ModalHeader, ModalFooter, Button, FormGroup, Label, Col, Input, InputGroup, InputGroupAddon, Form } from 'reactstrap';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import GeneralNavbar from '../general/GeneralNavbar';
import Footer from '../general/Footer';
import Message from '../general/Message';

const ProviderSubscriptionPricing = props => {

    // states
    const [subscriptionPlans, setSubscriptionPlans] = useState([]);
    const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState({});

    // contexts
    const { theme, colors } = useContext(ThemeContext);

    // utility functions


    // useEffects
    useEffect(() => {
        window.scrollTo(0, 0);
        GeneralService.getProviderSubscriptionPlans()
            .then(plans => {
                setSubscriptionPlans(plans.providerSubscriptionPlans)
                // console.log(plans);
            })
            .catch(err => {
                console.log(err);
            })
    }, []);


    // handle functions
    const handlePlanSelect = e => {
        // console.log(selectedSubscriptionPlan._id)
        if (selectedSubscriptionPlan._id) {
            try {
                props.history.push({
                    pathname: "/counsellor/landingScreen",
                    state: {
                        selectedSubscriptionPlan: selectedSubscriptionPlan
                    }
                });
            } catch (err) {
                console.log(err);
            }
        } else {
            Alert.error("Select a plan to continue.", {
                position: 'top-right',
                effect: 'slide'
            });
        }
    }


    // function's return
    return (
        <div>
            <GeneralNavbar history={props.history} />
            <div className='text-center m-5'>
                <div className='mb-5'>
                    <h1 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.8rem", fontWeight: "500", color: "#384E73" }}>Counsellor Subscriptions - Plans &amp; Pricings</h1>
                    <h2 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.2rem", fontWeight: "500" }}>Select the plan that best suits your needs.<br />You can update / cancel your subscription anytime.</h2>
                </div>

                {
                    subscriptionPlans.map((item, index) => (
                        <div key={index} className="d-inline-block col-8 col-sm-8 col-md-3 text-center px-2 py-3 m-3" style={selectedSubscriptionPlan._id === item._id ? theme.selectedSlotCard : theme.slotCard} onClick={() => setSelectedSubscriptionPlan(item)}>
                            <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{item.name}</h2>
                            <p>{`₹${item.amount / 100} / Month`}</p>
                            <div>
                                <p><i className='fas fa-check'></i> Upto {item.serviceDetails.sessionBookingLimit} Session Bookings</p>
                                <p><i className='fas fa-check'></i> Upto {item.serviceDetails.clientLimit} Clients</p>
                                <p><i className={`fas fa-${item.serviceDetails.modeOfServices.call ? 'check' : 'times danger_text_color'}`}></i> Call</p>
                                <p><i className={`fas fa-${item.serviceDetails.modeOfServices.chat ? 'check' : 'times danger_text_color'}`}></i> Chat</p>
                                <p><i className={`fas fa-${item.serviceDetails.modeOfServices.video ? 'check' : 'times danger_text_color'}`}></i> Video</p>
                                <p><i className={`fas fa-${item.serviceDetails.modeOfServices.inPerson ? 'check' : 'times danger_text_color'}`}></i> In Person</p>
                                <p><i className={`fas fa-${item.serviceDetails.createClientSubscriptionPlans ? 'check' : 'times danger_text_color'}`}></i> Create Client Subscription Plans</p>
                            </div>
                        </div>
                    ))
                }

                <div>
                    <p className='mx-auto my-3 pb-0'><b>Note*</b> - For paid plans, you will be charged only once your account is approved.</p>
                    <button className="btn mx-auto my-4" id="paymentBtn" type="button" style={theme.button} onClick={() => handlePlanSelect()}>
                        Start Counselling
                    </button>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default ProviderSubscriptionPricing;